import { CancelTokenSource } from 'axios';

import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';

export const UploadFlowRequestConfig: Omit<RestApiRequestConfig<FlowUploadRequestBody, FlowUploadQueryParams>, 'requestBody' | 'headers' | 'queryParams'> = {
  restApiVersion: '3.6',
  httpMethod: 'POST',
  endpoint: 'flows',
};

export enum UploadFlowErrorCodes {
  MALFORMED_REQUEST = 400000,
  INVALID_ATTACHMENT = 400086,
  GENERIC_PUBLISHING_ERROR = 400087,
  MISSING_FLOW_NAME = 400089,
  MISSING_FLOW_PAYLOAD = 400090,
  PUBLISHING_UNAUTHORIZED = 403007,
  INSUFFICIENT_STORAGE = 403008,
  SITE_NOT_FOUND = 404000,
  PROJECT_NOT_FOUND = 404005,
  FLOW_NOT_FOUND = 404027,
  INVALID_REQUEST_METHOD = 405000,
  FLOW_NAME_CONFLICT = 409041,
}

export interface FlowUploadQueryParams {
  overwrite: boolean;
}

export type FlowUploadRequestBody = Blob;

export interface FlowUploadResponse {
  flow: {
    id: string;
    webpageUrl: string;
  };
}

export function callViaApiService(
  body: FlowUploadRequestBody,
  headers: {[index: string]: string},
  queryParams: FlowUploadQueryParams,
  progressDispatcher?: (progres: any) => void,
  cancelToken?: CancelTokenSource
) {
  const config: RestApiRequestConfig<FlowUploadRequestBody, FlowUploadQueryParams> = {
    ...UploadFlowRequestConfig,
    requestBody: body,
    headers,
    queryParams,
    onUploadProgress: progressDispatcher,
    cancelToken
  };
  return makeRestApiRequest<Blob, FlowUploadResponse>(config);
}
